import ChainId from "./chainId";

export const DEFAULT_CHAIN_ID = ChainId.SEPOLIA;
